import React from "react";

import * as S from "./styles";
import iconPenEdit from "../../assets/icons/icon-pen-edit.png";

// Exibido abaixo dos cards de tipo de assinatura (ver ../signatureTypeCards)
// quando o tipo selecionado já tem credencial cadastrada (eletrônica ou
// digital) - dá acesso de volta ao cadastro/visualização, que antes só ficava
// disponível enquanto nada estivesse cadastrado (ver WarningBannerAssignature).
// Sem isso, depois de cadastrar, o usuário não tinha como ver ou trocar a
// assinatura sem abrir chamado de suporte.
const TEXTO_POR_TIPO = {
  E: "Assinatura eletrônica cadastrada com sucesso.",
  D: "Assinatura digital cadastrada com sucesso.",
};

const LINK_POR_TIPO = {
  E: "Editar assinatura eletrônica",
  D: "Editar assinatura digital",
};

const ConfirmationBannerAssignature = ({ type, onEditClick, maxWidth, loading }) => (
  <S.ConfirmationBanner maxWidth={maxWidth}>
    <img src={iconPenEdit} alt="" />

    <div className="confirmation-content">
      <p>{TEXTO_POR_TIPO[type]}</p>

      <button
        type="button"
        style={{ cursor: loading ? "default" : "pointer" }}
        disabled={loading}
        onClick={loading ? undefined : onEditClick}
      >
        {loading ? (
          <S.LinkSpinner />
        ) : (
          <b style={{ cursor: "pointer" }}>{LINK_POR_TIPO[type]}</b>
        )}
      </button>
    </div>
  </S.ConfirmationBanner>
);

export default ConfirmationBannerAssignature;
